// Mirrors flexinet-billing-api src/appsync-api/src/schema/features/billable-units.graphql:
//
//   enum BillableUnitStatus { DRAFT ACTIVE RETIRED }
//   type BillableUnit {
//       id: ID!
//       name: String!
//       description: String
//       meterId: ID!
//       meter: Meter
//       meteredUnitsPerBillableUnit: Int
//       status: BillableUnitStatus
//       createdByUsername: ID
//       createdByUser: User
//       created: AWSDateTime
//       updated: AWSDateTime
//   }
//
// createdByUser is not selected by any query in this module, so it is not typed here.
import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {Meter} from '../meters/types';

export enum BillableUnitStatus {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    RETIRED = 'RETIRED',
}

// FNP-802: a BillableUnit is the unit a customer is CHARGED in — "1000 Domains Managed".
// It owns the meter link and the conversion factor, so every RatePlan pricing it agrees
// on what the unit IS and can differ only on what it COSTS.
export type BillableUnit = {
    id: string,
    name: string,
    description?: string,
    meterId: string,
    // Resolved server-side by the BillableUnit.meter field resolver, so the list can show
    // the meter without a second round trip.
    meter?: Meter,
    // How many METERED units make ONE billable unit. 1000 => 1000 metered events are
    // charged as one unit. Defaults to 1 (1:1) at the write boundary.
    meteredUnitsPerBillableUnit?: number | null,
    status?: BillableUnitStatus,
    createdByUsername?: string,
    created?: string,
    updated?: string,
}

export interface IBillableUnitTableColumn extends ITableColumn {
    render?: (item: BillableUnit) => ReactNode;
}
